import LzMBase, { LzNBase } from "./Base";

export interface LzNConfigurations extends LzNBase {
    default_currency_id: number,
    default_language_id: number,
    default_country_id: number,
    default_locale_id: number,
}

class LzMConfigurations extends LzMBase implements LzNConfigurations {
    default_currency_id: number;
    default_language_id: number;
    default_country_id: number;
    default_locale_id: number;

    constructor(model?: LzNConfigurations, copyAll?: boolean) {
        super(model, copyAll);

        this.default_currency_id = +(model?.default_currency_id || 0);
        this.default_language_id = +(model?.default_language_id || 0);
        this.default_country_id = +(model?.default_country_id || 0);
        this.default_locale_id = +(model?.default_locale_id || 0);
    }
}

export default LzMConfigurations;
